<template>
  <div>
    <div
      class="text-center"
      v-if="!dataLoaded"
    >
      <v-progress-circular
        class="mt-6"
        color="primary"
        :size="50"
        indeterminate
      />
    </div>

    <div v-show="dataLoaded">
      <v-row class="my-0">
        <v-col
          cols="12"
          class="pt-0"
        >
          <v-card
            ref="mainCard"
            class="base-card pb-4 pl-4 shadow"
            :class="{
              'pr-4': !isVerticalScrollInTable,
              'pr-0': isVerticalScrollInTable
            }"
          >
            <v-data-table
              ref="table"
              class="base-table fixed-last-column shadow-for-last-column is-vertical-scroll elevation-0 mt-3"
              :class="{
                'shadow-last-column': isShadowForLastColumn
              }"
              :loading="tableLoading"
              :headers="tableHeaders"
              :items="commonWorkParent.list"
              :items-per-page="-1"
              loading-text="Загрузка"
              no-data-text="Нет данных"
              no-results-text="Не найдено"
              hide-default-footer
              fixed-header
              v-scroll.self="tableScroll"
            >
              <template v-slot:body.prepend="">
                <div
                  v-if="!tableLoading"
                  style="height: 1px"
                ></div>
              </template>

              <template v-slot:item.index="{ index }">
                {{ index + 1 }}
              </template>

              <template v-slot:item.authors="{ item }">
                {{ getAuthorsList(item.authors.list) }}
              </template>

              <template v-slot:item.actions="{ item }">
                <div class="table-icons">
                  <v-icon
                    class="uikit-icon eye show-btn"
                    title="Открыть"
                    @click="show(item)"
                  />
                  <v-icon
                    v-if="isAdmin"
                    class="uikit-icon edit-icon edit-btn"
                    title="Редактировать"
                    @click="edit(item)"
                  />
                  <v-icon
                    v-if="isAdmin"
                    class="uikit-icon trash remove-btn"
                    title="Удалить"
                    @click="remove(item)"
                  />
                </div>
              </template>

              <template slot="no-data">
                <div>Таблица пуста</div>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </div>
    <ConfirmDialog
      :dialog="confirmDialog"
      :loading="removeLoading"
      message="Подтвердите удаление работы"
      @confirm="removeCommonWork"
      @closeConfirmModal="confirmDialog = false"
    />
  </div>
</template>

<script>
import { commonWorkApi } from '@/api'
import { getWorkTypeNameById } from '@/scripts'
import { mapGetters } from 'vuex'
import { CommonWorkParent, Filters } from '@/models'
import { cloneDeep } from 'lodash'
import { shadowForLastColumn } from '@/mixins/shadowForLastColumn'
import { tableHeight } from '@/mixins/tableHeight'
import ConfirmDialog from '@/components/dialogs/Confirm.vue'
import { isVerticalScrollInTable } from '@/mixins/isVerticalScrollInTable'
import { setExcludeType } from '@/mixins/setExcludeType'

export default {
  name: 'DeclinePage',
  components: { ConfirmDialog },
  mixins: [shadowForLastColumn, tableHeight, isVerticalScrollInTable, setExcludeType],

  metaInfo: {
    title: 'Отклоненные работы'
  },

  props: {
    filtersProp: {
      type: Object
    },
    triggerSetTableHeight: {
      type: Boolean
    }
  },

  created() {
    this.setShowFilterFields()

    this.filters = new Filters(this.savedFilter('decline'))
    this.setExcludedTypeForShow()

    this.getCommonWorkParent()
  },

  data: () => ({
    tableHeaders: [
      { text: '№', value: 'index', sortable: false, align: 'start' },
      { text: 'ФИО cотрудника', value: 'authors', sortable: false, align: 'start' },
      { text: 'Показатель эффективности', value: 'workType.name', sortable: false, align: 'start' },
      { text: 'Год', value: 'year.year', sortable: false, align: 'start' },
      { text: 'Наименование работы', value: 'workName', sortable: false, align: 'start' },
      { text: 'Наименование издания', value: 'magazine.name', sortable: false, align: 'start' },
      { text: 'Действия', value: 'actions', sortable: false, align: 'center', width: '120px' }
    ],

    commonWorkParent: new CommonWorkParent(),
    tableLoading: false,
    selectedItem: null,
    confirmDialog: false,
    removeLoading: false,
    dataLoaded: false,
    pageNumber: 0,
    lastPage: false,
    total: 0,
    errorLoad: false,
    filters: new Filters(),
    excludeTypes: [19]
  }),

  computed: {
    ...mapGetters('user', [
      'userId',
      'isAdmin',
      'isModerator',
      'isModeratorNir',
      'isModeratorDiss',
      'isModeratorGrantContest',
      'isModeratorScientificEvent'
    ]),
    ...mapGetters('filters', ['savedFilter'])
  },

  methods: {
    setShowFilterFields() {
      this.$emit('setShowFilterFields', {
        isShowSearchString: false,
        isShowWorkTypeId: true,
        isShowStatusId: false,
        isShowYearId: false,
        isShowDepartmentList: false,
        isShowFIO: false,
        isShowEmployeeId: true,
        isShowPeriodId: true,
        isShowEfficiencyIndicator: false
      })
    },

    async getCommonWorkParent() {
      if (this.errorLoad) return
      try {
        if (!this.lastPage) {
          this.tableLoading = true
          this.filters.setExcludedType(this.excludeTypes)

          this.filters.statusId = 5
          const { content, last, totalElements } = await commonWorkApi.findAllByFilters(
            this.pageNumber,
            this.filters.getForAPI()
          )
          if (this.pageNumber === 0) this.commonWorkParent.list = []
          this.lastPage = last
          this.total = totalElements
          this.pageNumber++

          content.length &&
            content.forEach(obj => {
              this.commonWorkParent.add(obj?.work.commonWork)
              const currentCommonWork = this.commonWorkParent.list.find(el => el.id === obj.work?.commonWork.id)
              if (currentCommonWork) currentCommonWork.magazine = obj.work?.magazine
            })
          this.checkHeightElementAndChangeIsVerticalScrollInTable()
          this.tableLoading = false
        }
      } catch (e) {
        console.log(e)
        if (e) {
          this.tableLoading = false
          this.errorLoad = true
          this.showErrorMessage(e, 'Не удалось получить список работ')
        } else this.tableLoading = true
      } finally {
        this.dataLoaded = true
      }
    },

    getFullEngName(author) {
      return `${author.lastNameEng || ''} ${author.firstNameEng || ''} ${author.middleNameEng || ''}`
    },

    getAuthorsList(authorList) {
      let authors = ''
      for (const author of authorList)
        authors +=
          (author.employee?.fullName ||
            author.nameRus ||
            this.getFullEngName(author) ||
            'Отсутствует информации об имени') + ', '
      authors = authors.slice(0, -2)
      return authors
    },

    setExcludedTypeForShow() {
      this.setExcludedType()
      this.$emit('setExcludeTypes', this.filters.excludedType)
    },

    show(item) {
      this.$router.push('/works/' + getWorkTypeNameById(item.workType.id) + '/show/' + item.workId)
    },

    edit(item) {
      this.$router.push('/works/' + getWorkTypeNameById(item.workType.id) + '/edit/' + item.workId)
    },

    remove(item) {
      this.selectedItem = item
      this.confirmDialog = true
    },

    async removeCommonWork() {
      this.removeLoading = true

      try {
        await commonWorkApi.remove(this.selectedItem.id)
        this.$toast.info('Успешно удалено')
        this.commonWorkParent.remove(this.selectedItem.id)

        this.confirmDialog = false
        this.selectedItem = null

        this.pageNumber--
        this.lastPage = false
        this.total = 0
        this.getCommonWorkParent()
      } catch (e) {
        console.log(e)
        this.showErrorMessage(e, 'Не удалось удалить работу')
      } finally {
        this.removeLoading = false
      }
    },

    tableScroll(event) {
      const el = event.target
      if (el.scrollHeight - el.clientHeight - el.scrollTop <= 10 && !this.tableLoading) {
        this.getCommonWorkParent()
      }
    }
  },

  watch: {
    dataLoaded() {
      this.setTableHeight()
    },

    triggerSetTableHeight() {
      this.setTableHeight()
    },

    filtersProp: {
      deep: true,
      async handler(val) {
        if (this.dataLoaded) {
          this.filters = cloneDeep(val)
          this.pageNumber = 0
          this.lastPage = false
          this.total = 0
          if (this.userId) {
            await this.getCommonWorkParent()
          }
        }
      }
    }
  }
}
</script>

<style scoped></style>
